// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__qfPcQ","inner":"Footer_inner__cxsoy"};